"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiddenChatsContext = void 0;
const ChatsContext_1 = require("./ChatsContext");
exports.HiddenChatsContext = (0, ChatsContext_1.createChatContext)();
